module.exports = __webpack_public_path__ + "img/Objet dynamique vectoriel4-05.5672910d.png";